import { render, staticRenderFns } from "./sheetDetails.vue?vue&type=template&id=c8b1518c&scoped=true&"
import script from "./sheetDetails.vue?vue&type=script&lang=js&"
export * from "./sheetDetails.vue?vue&type=script&lang=js&"
import style0 from "./sheetDetails.vue?vue&type=style&index=0&id=c8b1518c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b1518c",
  null
  
)

export default component.exports